import React from 'react';
import { Menu } from 'semantic-ui-react';

export default function CategoryNavigation(props) {
  const { categories } = props;

  return (
    <Menu
      className="fc-menu-category-navigation"
      secondary
      attached="top"
      items={createCategoryMenuItems(categories)}
    />
  )
}

function createCategoryMenuItems(categories) {
  return categories.map(({ name }) =>({
    key: name,
    name: name,
    href: `#${name}`,
    content: <h3>{name}</h3>
  }))
}